import R from '../images_02/Rec.jpg';


const blogMeta = [
    {
      image: R,
      id: 'blog-1',
      title: 'House Decor Ideas to Instantly Upgrade Your Home Without Renovation',
      description: 'Discover smart house decor ideas to instantly upgrade your home without renovation. Simple, stylish, and budget-friendly decor tips by experts.',
    },
    {
      image: R,
      id: 'blog-2',
      title: 'Title 2',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
    {
      image: R,
      id: 'blog-3',
      title: 'Title 3',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
    {
      image: R,
      id: 'blog-4',
      title: 'Title 4',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
  ];
  
  export default blogMeta;